module.exports = __webpack_public_path__ + "c53136193516ed2d4fac337d1dc6965a.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-bolditalic-webfont.woff
 ** module id = ./src/styles/fonts/lato/lato-bolditalic-webfont.woff
 ** module chunks = 0
 **/